import _ from 'lodash'
import * as React from 'react'
import { Card, CardBody } from 'reactstrap'

import BadgeLabel from 'components/common/BadgeLabel/BadgeLabel'

type Props = {
  amount: string
  ratio?: string
  badgeLabel: string
  badgeColor: string
  className?: string
}

const AmountCard: React.FC<Props> = ({ amount, ratio, badgeLabel, badgeColor, className }) => {
  return (
    <Card className={className}>
      <CardBody>
        <div className="d-flex">
          <BadgeLabel label={badgeLabel} color={badgeColor} />
        </div>
        <div className="d-flex flex-wrap justify-content-center align-items-baseline pt-2 px-3">
          <div className="font-x-large fw-bold me-1">{amount}</div>
          <div>円</div>
          {ratio && (
            <>
              <div className="font-x-large fw-bold ms-3 me-1">{_.floor(Number(ratio), 2).toFixed(2)}</div>
              <div>%</div>
            </>
          )}
        </div>
      </CardBody>
    </Card>
  )
}

export default AmountCard
